import React from 'react';
import { OrderLinesListTemplate } from 'themes/modules/order/pages';
import { OrderLinesListViewStore } from 'modules/order/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new OrderLinesListViewStore(rootStore, componentProps),
	'orderLinesListViewStore'
)
class OrderLinesList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <OrderLinesListTemplate {...this.props} viewStore={this.props.orderLinesListViewStore} />;
	}
}

export default OrderLinesList;



// WEBPACK FOOTER //
// ./src/modules/order/pages/OrderLinesList.jsx